/**
 * Created by rickborst on 24/07/2017.
 */

class PaymentHistory {

    /**
     * Constructs the model.
     *
     * @param {Object} data - Payment history entry data.
     * @returns {PaymentHistory} Payment history item.
     */
    constructor (data) {

        this.timestamp = data.timestamp || 0;
        this.invoiceUrl = data.invoiceUrl || '';

        return this;
    }
}

export default PaymentHistory;


// WEBPACK FOOTER //
// ./src/js/models/paymenthistory.js